module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGc8f4d5f56f8d6959e077f3d570c65ddd.c8f4d5f5.png";